export const Paper = {
  MuiPaper: {
    styleOverrides: {
      elevation24: {
        boxShadow:
          '0 0.46875rem 2.1875rem rgba(8,10,37,.03), 0 0.9375rem 1.40625rem rgba(8,10,37,.03), 0 0.25rem 0.53125rem rgba(8,10,37,.05), 0 0.125rem 0.1875rem rgba(8,10,37,.03)',
      },
    }
  },
};
